export default __webpack_public_path__ + "static/media/logo-mobile-terms-of-use-new.2f2ceee3.png";